import * as React from 'react';
import styled, { withTheme, keyframes, css } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { OutsideClick } from '../../../Defaults/OutsideClick';
import { Title } from '../../General/Title';
import { SvgIcon, IconType } from '../../General/SvgIcon';
import {
  FlexCol,
  FlexRowCenter,
  FlexColCenter,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { Button, ButtonLink } from '../../General/Button';
import { ModalItemsTable } from './ModalItemsTable';
import { MinAmountInfoText } from './MinAmountInfoText';
import { AddedToCartProduct } from './AddedToCartProduct';

export interface Props {
  handleClose: any;
  handleToCartButtonClick: any;
  product: any;
  children: any;
  theme: any;
  count: number;
  isRequest: boolean;
  isLoggedIn: boolean;
}

function WasAddedToCartModal({
  handleClose,
  handleToCartButtonClick,
  product,
  theme,
  children,
  count,
  isRequest,
  isLoggedIn,
}: Props) {
  return (
    <AddAccountWrapper>
      <ModalStyle />
      <ModalHolder>
        <OutsideClickWrapper>
          <OutsideClick handleFunction={handleClose}>
            <Wrapper>
              <TitleWrapper>
                <FlexRowCenterVertical>
                  <IconWrapper>
                    <SvgIcon
                      width={48}
                      height={48}
                      marginRight={16}
                      viewBox="0 0 48 48"
                      icon={IconType.finishedOrder}
                      alt=""
                      title=""
                      fill={theme.colors.stockCountAvailable}
                    />
                  </IconWrapper>
                  <Title marginTop={0} marginBottom={0}>
                    {isRequest
                      ? __('Pridané do dopytu')
                      : __('Pridané do košíka')}
                  </Title>
                </FlexRowCenterVertical>
                <SvgIcon
                  onClick={handleClose}
                  width={24}
                  height={24}
                  icon={IconType.close}
                  alt="Zavrieť okno"
                  title="Zavrieť okno"
                  fill={theme.colors.textPrimary}
                  cursor={'pointer'}
                />
              </TitleWrapper>
              <AddedToCartProduct
                isRequest={isRequest}
                count={count}
                product={product}
                isLoggedIn={isLoggedIn}
              />
              <ButtonWrapper>
                <ToOrderButton onClick={handleToCartButtonClick}>
                  {isRequest ? __('Dokončiť') : __('Dokončiť objednávku')}
                </ToOrderButton>
                <CloseButton onClick={handleClose}>
                  {__('Pokračovať v nakupovaní')}
                </CloseButton>
              </ButtonWrapper>
              {children}
            </Wrapper>
          </OutsideClick>
        </OutsideClickWrapper>
      </ModalHolder>
    </AddAccountWrapper>
  );
}

const OutsideClickWrapper = styled.div`
  width: 100%;
  max-width: ${rem(656)};
`;

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexCol)`
  padding: ${rem(32)};
  width: 100%;
  position: relative;
  opacity: 1;
  background: white;
  border-radius: ${rem(4)};
  margin: ${rem(16)} auto;
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  display: block;
  animation: ${animateIn} 0.15s ease;

  ${({ theme }) => theme.mediab.m580`
      padding: ${rem(24)};
      margin: ${rem(16)};
      width: initial;
  `};
`;

const IconWrapper = styled.div`
  ${({ theme }) => theme.mediab.m600`
    display: none;
  `};
`;

const AddAccountWrapper = styled.div``;

const TitleWrapper = styled(FlexRowCenter)`
  justify-content: space-between;
  margin-bottom: ${rem(32)};

  ${({ theme }) => theme.mediab.m600`
      margin-bottom: ${rem(32)};
      margin-top: 0;
  `};
`;

const buttonCss = css`
  height: ${rem(48)};
  padding: 0 ${rem(16)};
  width: 100%;
  max-width: ${rem(288)};
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  border-radius: ${rem(2)};
  margin: 0;

  &:disabled {
    background-color: #dcd6d6;
  }

  ${({ theme }) => theme.mediab.m600`
    max-width: initial;
    margin-top: 0;
  `}
`;

const ToOrderButton = styled(ButtonLink)`
  ${buttonCss};

  ${({ theme }) => theme.mediab.m600`
    margin-bottom: ${rem(16)};
  `}
`;

const CloseButton = styled(Button)`
  ${buttonCss};
  background-color: white;
  border: ${({ theme }) => theme.borders.primary};
`;

const ButtonWrapper = styled(FlexRowCenterVertical)`
  margin: ${rem(24)} 0 ${rem(32)};
  justify-content: space-between;

  ${({ theme }) => theme.mediab.m600`
    flex-flow: column;
    margin: 0;
  `}
`;

const ModalHolder = styled(FlexColCenter)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.index.modal};
`;

const ModalStyle = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.2;
  z-index: ${({ theme }) => theme.index.modal};
`;

const WithThemeComponent: any = withTheme(WasAddedToCartModal);
export { WithThemeComponent as WasAddedToCartModal };
